import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Vinay Dubey`}</h1>
    <p>{`I am a MERN Stack developer who builds single-page and eCommerce applications. I have project wise experience in full-stack development (React.js, Redux.js,Node.js, Express.js, MongoDB). Other Languages and Tech I had dabbled are PYTHON.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      